import NimblePicker, {
  NimblePickerProps,
} from "emoji-mart/dist-es/components/picker/nimble-picker";
import * as React from "react";
import { setData, setName, fetchBackgroundImage } from "../constants";
import "./style.css";
import { useTranslation } from "react-i18next";

export const EmojiPicker = (
  props: Omit<
    NimblePickerProps,
    | "set"
    | "data"
    | "sheetSize"
    | "showPreview"
    | "showSkinTones"
    | "backgroundImageFn"
    | "darkMode"
    | "emojiSize"
    | "notFoundEmoji"
  >
) => {
  const { t } = useTranslation();
  const i18n = React.useMemo(
    () => ({
      search: t("emoji.search"),
      notfound: t("emoji.not_found"),
      clear: t("emoji.clear"),
      skintext: t("emoji.skin_text"),
      categories: {
        search: t("emoji.categories.search"),
        recent: t("emoji.categories.recent"),
        people: t("emoji.categories.people"),
        nature: t("emoji.categories.nature"),
        foods: t("emoji.categories.foods"),
        activity: t("emoji.categories.activity"),
        places: t("emoji.categories.places"),
        objects: t("emoji.categories.objects"),
        symbols: t("emoji.categories.symbols"),
        flags: t("emoji.categories.flags"),
        custom: t("emoji.categories.custom"),
      },
      categorieslabel: t("emoji.categories_label"),
    }),
    [t]
  );

  return (
    <NimblePicker
      {...props}
      style={{ width: "100%", height: "340px", overflow: "hidden" }}
      title={t("emoji.title")}
      i18n={i18n}
      set={setName}
      data={setData}
      sheetSize={20}
      showPreview={false}
      showSkinTones={false}
      backgroundImageFn={fetchBackgroundImage}
      notFoundEmoji={""}
    />
  );
};
